export class FilterModel {
  public id = '';
  public name = '';
  public partNumber = '';
  public lineOfService = '';
  public productLine = '';
  public description = '';
  public type: 'Machine' | 'Part';
  public effectiveDate: Date;
  public isExpense: boolean;
  public truckStock: boolean;
  public showInactive = false;
  public requiresAudit: 'Yes' | 'No';
  make: string;
  model: string;
}
